export const EMPTY_ROUTE_HISTORY_MASK = "!";
